/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#welcome[_ngcontent-%COMP%]{font-weight:700!important}.sub-text[_ngcontent-%COMP%]{font-size:15px!important}\n/*# sourceMappingURL=cancelled.component.css.map*/"];
export { styles as styles };
